import React, { useContext, useMemo } from "react";
import { SearchForPlanCellDrawer } from "./SearchForPlanCellDrawer";
import { IntakeDrawer } from "./intake/IntakeDrawer";
import {
  DrawerSelection,
  Plan2PlateDrawer,
  usePlan2PlateDisclosure,
} from "./Plan2PlateDrawer";
import { PlanCellCoordinates } from "../data/plan";
import { DrawerHistoryContext, MealPlannerContext } from "../contexts";
import { isDeleted } from "../utils/editUtils";
import { PlanCoordinateHeader } from "./PlanCoordinateHeader";

export function AddPlanCellDrawer(props: {
  planCellCoordinates: PlanCellCoordinates | undefined;
  onClose: () => void;
  open: boolean;
}) {
  const drawerHistoryContext = useContext(DrawerHistoryContext);
  const { isOpen, onOpen, onClose } = usePlan2PlateDisclosure(
    drawerHistoryContext,
    "search-for-plan-cell",
  );
  const {
    isOpen: isOpenIntake,
    onOpen: onOpenIntake,
    onClose: onCloseIntake,
  } = usePlan2PlateDisclosure(drawerHistoryContext, "intake");
  const { getTableDataForCoordinates, submitPlanCells } =
    useContext(MealPlannerContext);

  const tableDataForCoordinates = useMemo(
    () =>
      props.planCellCoordinates
        ? getTableDataForCoordinates(props.planCellCoordinates)
        : [],
    [getTableDataForCoordinates, props.planCellCoordinates],
  );

  return (
    <>
      {props.planCellCoordinates && (
        <>
          <SearchForPlanCellDrawer
            onClose={onClose}
            open={isOpen}
            onSubmit={() => {
              onClose();
              props.onClose();
            }}
            planCellCoordinates={props.planCellCoordinates}
            planMode="plan"
          />
          <IntakeDrawer
            onClose={onCloseIntake}
            open={isOpenIntake}
            onSubmit={() => {
              onCloseIntake();
              props.onClose();
            }}
            planCellCoordinates={props.planCellCoordinates}
          />
        </>
      )}
      <Plan2PlateDrawer
        onClose={props.onClose}
        open={props.open}
        header={
          <PlanCoordinateHeader
            planCellCoordinates={props.planCellCoordinates}
          />
        }
        body={
          <>
            <DrawerSelection
              dataCy="drawer-selection-plan"
              onClick={() => {
                onOpen();
              }}
              icon={"mealPlan"}
              heading={"Planen"}
              description={"Erstelle deinen persönlichen Ernährungsplan"}
            />
            <DrawerSelection
              dataCy="drawer-selection-intake"
              onClick={() => {
                onOpenIntake();
              }}
              icon="intake"
              heading={"Verzehren"}
              description={"Erfasse, was du tatsächlich gegessen hast"}
            />
            {!!tableDataForCoordinates.filter((t) => !isDeleted(t.planCell))
              .length && (
              <DrawerSelection
                dataCy="drawer-selection-delete"
                onClick={() => {
                  if (props.planCellCoordinates) {
                    const tableDataForCoordinates = getTableDataForCoordinates(
                      props.planCellCoordinates,
                    );
                    submitPlanCells(
                      tableDataForCoordinates.map((d) => ({
                        ...d,
                        planCell: { ...d.planCell, deleted: true },
                      })),
                    );
                  }
                  props.onClose();
                }}
                icon="delete"
                heading={"Löschen"}
                description={"Lösche alles was du geplant oder verzehrt hast"}
              />
            )}
          </>
        }
      />
    </>
  );
}
